import React from 'react';
import PropTypes from 'prop-types';
// vp UI
import { Link } from '@vp/swan';

const EmbeddableLink = ({
  href,
  onClick,
  children,
  isCta,
  navToNewWindow,
  tabIndex,
}) => {
  if (!(href || onClick)) {
    return children;
  }

  return (
    <Link
      href={href}
      onClick={onClick}
      target={navToNewWindow ? '_blank' : '_self'}
      key={href}
      skin={isCta ? 'cta' : undefined}
      tabIndex={tabIndex}
    >
      {children}
    </Link>
  );
};
EmbeddableLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  isCta: PropTypes.bool,
  navToNewWindow: PropTypes.bool,
  tabIndex: PropTypes.number,
};

/**
 * Component builder to build specifically a Linked Button
 * (using either 'href' or 'onClick' properties) that is suitable to be used
 * with the ReplaceTokens facility.  The optional 'navToNewWindow' allows specifying
 * that the response will display on a new window.
 *
 * Usage:
 *    const GoToBasketLink = EmbeddableLinkCreator({ href: navToCart });
 *    const GoToBillingAddressLink = EmbeddableLinkCreator({ onClick: () => navigate(BILLING_ADDRESS_STEP) });
 * @param {*} param0
 */
export const EmbeddableLinkCreator =
  ({ href, onClick, isCta, tabIndex, navToNewWindow }) =>
  ({ children }) =>
    EmbeddableLink({
      href,
      onClick,
      isCta,
      tabIndex,
      navToNewWindow,
      children,
    });
